module.exports = __webpack_public_path__ + "img/search-black-18dp.66531531.svg";